import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'underscore';

@Pipe({
  name: 'location'
})
export class LocationPipe implements PipeTransform {
  transform(location: string): string {
    return LocationPipe.transform(location);
  }

  static transform(location: string): string {
    return location === 'Unspecified' || _.isEmpty(location)
      ? 'workloadManager.listContainer.noInformationMsg'
      : location;
  }
}
